import { render, staticRenderFns } from "./DatabaseReader.vue?vue&type=template&id=3beb093d"
import script from "./DatabaseReader.vue?vue&type=script&lang=ts"
export * from "./DatabaseReader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3beb093d')) {
      api.createRecord('3beb093d', component.options)
    } else {
      api.reload('3beb093d', component.options)
    }
    module.hot.accept("./DatabaseReader.vue?vue&type=template&id=3beb093d", function () {
      api.rerender('3beb093d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/DatabaseReader.vue"
export default component.exports